export default "__VITE_ASSET__ab91e529__"